import '@Global/home-page';
import '@Global/create-from-scratch';
import type {ReactElement} from 'react';
import {ModalContainer} from '@Components/modal-container';
import App from '@Components/app';
import {renderApp} from '@Utils/renderApp.util';

export function HomePageApp(): ReactElement {
  return (
    <App>
      <ModalContainer />
    </App>
  );
}

renderApp(<HomePageApp />, 'home-page-app');
